import styled from "styled-components";

export const ExternalContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const InternalContainer = styled.div`
  display: flex;
  width: 100%;
  ${(props) =>
    props.noPadding ? 
      `
      max-width: 1536px;
      padding-left: 0px;
      padding-right: 0px;
      ` :
    props.largeScreen
      ? `max-width: 1512px;
         padding-left: 48px;
         padding-right: 48px;`
      : `
      padding-left: 30px;
      padding-right: 30px;
  `}
`;
